// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.approach_grid__I2r-F {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0 var(--space-7);
}
.approach_item__GmzG2 {
  padding: var(--space-6) 0;
  border-top: 1px solid var(--color-border);
}
.approach_head__qum-w {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}
.approach_num__4vS4r {
  font-size: var(--text-caption);
  font-weight: 700;
  color: var(--kur-amber);
  font-variant-numeric: tabular-nums;
}
.approach_fact__p6FBs {
  padding: 0.35rem 0.85rem;
  font-size: var(--text-caption);
  font-weight: 700;
  background: var(--color-ink);
  color: #fff;
  border-radius: var(--radius-pill);
}
.approach_title__08T0A {
  margin: 0 0 var(--space-3);
  font-size: var(--text-h3);
  font-weight: 500;
  line-height: var(--leading-heading);
}
.approach_text__oLGIo {
  margin: 0;
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}

@media (min-width: 900px) {
  .approach_grid__I2r-F {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SPONSORS/SECTIONS/APPROACH/approach.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".grid {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0 var(--space-7);\n}\n.item {\n  padding: var(--space-6) 0;\n  border-top: 1px solid var(--color-border);\n}\n.head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n.num {\n  font-size: var(--text-caption);\n  font-weight: 700;\n  color: var(--kur-amber);\n  font-variant-numeric: tabular-nums;\n}\n.fact {\n  padding: 0.35rem 0.85rem;\n  font-size: var(--text-caption);\n  font-weight: 700;\n  background: var(--color-ink);\n  color: #fff;\n  border-radius: var(--radius-pill);\n}\n.title {\n  margin: 0 0 var(--space-3);\n  font-size: var(--text-h3);\n  font-weight: 500;\n  line-height: var(--leading-heading);\n}\n.text {\n  margin: 0;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n\n@media (min-width: 900px) {\n  .grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `approach_grid__I2r-F`,
	"item": `approach_item__GmzG2`,
	"head": `approach_head__qum-w`,
	"num": `approach_num__4vS4r`,
	"fact": `approach_fact__p6FBs`,
	"title": `approach_title__08T0A`,
	"text": `approach_text__oLGIo`
};
export default ___CSS_LOADER_EXPORT___;
